module.exports = __webpack_public_path__ + "img/rwanda.82a2168.webp";